'use client';

// Imperative open/close for the simulated trade flow explainer (spec 115).
// A single `<SimulatedTradeModal />` is mounted at the AppShell root; any
// how-it-works modal can hand off to it via `setOpen(true)` — same pattern as
// the graduation / manipulation explainers.

import type { StoreApi, UseBoundStore } from 'zustand';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

export interface SimulatedTradeModalState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useSimulatedTradeModalStore: UseBoundStore<StoreApi<SimulatedTradeModalState>> =
  createTrackedStore<SimulatedTradeModalState>('useSimulatedTradeModalStore')((set) => ({
    open: false,
    setOpen: (open: boolean): void => set({ open }),
  }));
